import React, { memo } from 'react'

import { useMediaQueries } from 'hooks'

import Link from 'components/_old/Link/Link.jsx'
import { Typo } from 'components/_old/Typo'
import Width from 'components/_old/Width/Width'

import { Paper } from 'components/atoms/Paper'
import { Typography } from 'components/atoms/Typography'

import {
  AvailableToTransferFrom,
  BackLink,
  Title,
  Description,
  TransfersInProgress,
  StartANewTransferLink,
  Faq,
} from '..'

import './Content.css'

const Content = memo(() => {
  const { desktop } = useMediaQueries()

  return (
    <Width size={60} center>
      {desktop && <BackLink />}

      <Paper top={desktop ? 40 : undefined}>
        <div className="TransferCentre-Grid">
          <Title className="TransferCentre-Title" />
          <Paper top={desktop ? undefined : 16} className="TransferCentre-Content">
            <Description />
            <Paper top={48}>
              <TransfersInProgress />
            </Paper>
            <Paper top={desktop ? 32 : 24}>
              <Typography lineHeight="small">
                <Typo>
                  Need to update a transfer or have a question?{' '}
                  <Link to="https://help.investengine.com/hc/en-gb/requests/new" blank hard>
                    Contact us
                  </Link>
                </Typo>
              </Typography>
            </Paper>
            {desktop && (
              <Paper top={32}>
                <StartANewTransferLink />
              </Paper>
            )}
            <Paper top={desktop ? 32 : 48}>
              <AvailableToTransferFrom logoSize={desktop ? 56 : 48} />
            </Paper>
          </Paper>

          <Faq className="TransferCentre-Faq" />
        </div>
      </Paper>
    </Width>
  )
})
Content.displayName = 'Content'
export { Content }
